import React from 'react'
import {
  DialogActions,
  DialogActionsProps,
} from 'components/Dialog'
import { useViewport } from 'hooks'

export type FiltersDialogFooterProps = DialogActionsProps

export const FiltersDialogFooter: React.FC<FiltersDialogFooterProps> = ({ sx, ...props }) => {
  const { isMedium } = useViewport()

  return <DialogActions {...props as DialogActionsProps} sx={[
    (theme) => ({
      p: isMedium ? 3 : 2,
      display: 'flex',
      gap: 1,
      justifyContent: 'normal',
      '&>.MuiBox-root': {
        width: { xs: '50%', md: 'auto' },
      },
      '& :last-child': {
        ml: { md: 'auto !important' },
      },
      [theme.breakpoints.up('xs')]: {
        flexDirection: 'row',
      },
      [theme.breakpoints.up('md')]: {
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: theme.palette.divider,
      },
    }),
    ...(Array.isArray(sx) ? sx : [sx])
  ]} />
}

export default FiltersDialogFooter
